import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@app/core/authentication/services/auth.service';
import { Link } from '@app/core/models/atomics.model';
import { UserService } from '@app/core/user/user.service';
import { Customer } from '@app/core/user/utilities/user.model';

import { ForgotPasswordService } from '@b2b/features/forgot-password-dialog/core/forgot-password.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'my-account-floating-menu',
  imports: [CommonModule, RouterModule],
  templateUrl: './my-account-floating-menu.component.html',
  styleUrl: './my-account-floating-menu.component.scss',
})
export class MyAccountFloatingMenuComponent {
  @Input({ required: true }) links!: Link[];

  user$: Observable<Customer | null> = this.userService.get();

  constructor(
    private router: Router,
    private userService: UserService,
    private forgotPasswordService: ForgotPasswordService,
    private authService: AuthService,
  ) {}

  onLinkClick(event: Event, link: Link) {
    event.preventDefault();
    if (link.uid === 'profile-change-password') {
      // Open the forgot password modal for password change
      this.openChangePasswordModal();
      return;
    }
    if (link.uid === 'profile-logout') {
      this.authService.logout();
      return;
    }
    this.router.navigateByUrl(link.url || '');
  }

  openChangePasswordModal() {
    this.forgotPasswordService.openModal();
  }
}
